var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-property-decorator";
import axois from 'axios';
import Loader from "./shared/loader.vue";
import { orderBy } from "lodash-es";
var Advisories = /** @class */ (function (_super) {
    __extends(Advisories, _super);
    function Advisories() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.advisories = null;
        _this.errorMessage = '';
        _this.loading = true;
        return _this;
    }
    Advisories.prototype.created = function () {
        var _this = this;
        this.loading = true;
        axois.post(window.api_url.replace(new RegExp('\/$'), '') + '/advisories').then(function (response) {
            if (response.status !== 200) {
                _this.errorMessage = 'Advisories server can not be contacted at this time, please try again later.';
                return;
            }
            _this.advisories = orderBy(response.data.advisories, ['start', 'last_updated'], 'desc');
        }).catch(function (response) {
            _this.errorMessage = 'There was an error fetching the advisories, please try again later.';
        }).finally(function () {
            _this.loading = false;
        });
    };
    Advisories.prototype.parseMarkup = function (text) {
        return text.replace(/\n?-{4,}\n*/g, '<hr class="mt-3">')
            .replace(/\n/g, '<br>');
    };
    Advisories = __decorate([
        Component({
            components: {
                Loader: Loader,
            }
        })
    ], Advisories);
    return Advisories;
}(Vue));
export default Advisories;
